import Commerce from '@chec/commerce.js';

export const commerce = new Commerce('pk_33763cd8f890feb96eaa00304e090f40a58714e177a7a',true);
// pk_test_33763d845cd70611e1c163280d3dc053eb1faf964622d

// sk_33763490b0562f7337bdd14a1066d0b6002ba4a1ba433

// export const commerce = new Commerce(process.env.REACT_APP_CHEC_PUBLIC_KEY,true);